import ConstraintTypesEmpty from './ConstraintTypesEmpty';
import './ConstraintTypesEmpty.css';
export default ConstraintTypesEmpty;
